module.exports = __webpack_public_path__ + "static/media/Quilpue.364cf420.png";